export default __webpack_public_path__ + "static/media/online-exam.0be13c7a.svg";